import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import FinancialStatusIcon from '../status/FinancialStatusIcon';
import Text from 'components/_UI/Text';
import date from 'helpers/date';
import time from 'helpers/time';
import currency from 'helpers/currency';
import { DollarSign } from 'lucide-react';
import { FullyCentered } from 'styled/alignment/Center';

export default function GeneralTransactions({ data }) {
    const transactionTypes = {
        withdraw: 'withdraw',
        refund: 'refund',
        sell: 'sell'
    }

    return (
        <TransactionContainer>
            {data && data?.length > 0 ? (
                data.map((transaction, index) => (
                    <React.Fragment key={transaction.id}>
                        <TransactionItem>
                            <Row style={{ alignItems: 'center' }}>
                                <FinancialStatusIcon status={transaction?.category} />
                                <TextInfoContent>
                                    <Text paddingBottom={0} color={colors.nightDark}>
                                        {transaction.description}
                                    </Text>
                                    <Text paddingBottom={0} name='small' color={colors.night}>
                                        {`${date.format(transaction.created_at)} - ${time.getFormatedTime(transaction.created_at)}`}
                                    </Text>
                                </TextInfoContent>
                            </Row>

                            <PriceColumn>
                                {(transaction?.category === transactionTypes.refund || transaction?.category === transactionTypes.withdraw) && (
                                    <AmountText color={colors.danger}>
                                        -{currency.format(transaction.liquid_value)}
                                    </AmountText>
                                )}

                                {transaction?.category === transactionTypes.sell && (
                                    <AmountText color={colors.success}>
                                        {currency.format(transaction.liquid_value)}
                                    </AmountText>
                                )}

                                <StatusBadge status='success'>
                                    Processado
                                </StatusBadge>
                            </PriceColumn>
                        </TransactionItem>
                        {index < data.length - 1 && <Divider />}
                    </React.Fragment>
                ))
            ) : (
                <NotFoundContainer>
                    <PigIconContainer>
                        <DollarSign size={22} color={colors.occasionalPurple} />
                    </PigIconContainer>
                    <Text type='bold' name='normal' color={colors.nightDark} paddingBottom={'4px'}>
                        Você não possui transações recentes
                    </Text>
                    <Text textAlign='center' name='small' color={colors.night}>
                        Suas próximas transações serão listadas aqui.
                    </Text>
                </NotFoundContainer>
            )}
        </TransactionContainer>
    )
}


const TransactionContainer = styled(Column)`
`;

const TextInfoContent = styled(Column)`
    width: auto;
`;

const TransactionItem = styled(Row)`
    padding: 14px 4px;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    transition: background 0.15s ease;

    &:hover {
        background: ${colors.neutral};
    }
`;

const Divider = styled.div`
    height: 1px;
    background: ${colors.neutralDark};
    margin: 0 4px;
`;

const PriceColumn = styled(Column)`
    width: auto;
    min-width: 120px;
    padding: 0 4px;
    text-align: right;
    align-items: flex-end;
`;

const AmountText = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${({ color }) => color};
`;

const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    margin-top: 4px;
    font-size: ${fonts.sizes.mini};
    font-weight: 600;
    border-radius: 50px;
    letter-spacing: 0.2px;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
    `};

    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
    `};
`;

const PigIconContainer = styled(FullyCentered)`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${colors.occasionalPurple}10;
    margin-bottom: 12px;
`;

const NotFoundContainer = styled(FullyCentered)`
    flex-direction: column;
    padding: 40px 1.5em;
`;
